import React from 'react'
import {ScanGo} from '../../../images/index'
import SecondaryButton from '../../../components/Buttons/SecondaryButton'
import { useHistory } from 'react-router-dom'
import useApp from '../../../store/app/appContext'

function Scan_Go() {

  const { appState: { isAuthenticated } } = useApp();
  const history = useHistory();

  const scheduleScan = () => {
    if (isAuthenticated) {
      history.push('/scanandgo')
    } else {
      history.push('/login?scanandgo=true')
    }
  }
  
  return (
    <div id="ScanAndGo" className="bg-white mt-12 mb-20 lg:mt-0 pt-16 lg:py-24">
      <div className="pb-16 bg-blueD lg:pb-0 lg:z-10 lg:relative">
        <div className="lg:mx-auto lg:max-w-7xl lg:px-8 flex flex-col lg:flex-row-reverse lg:gap-8">
          <div className="relative lg:-my-8 transform -translate-y-12  lg:transform-none">
            <div className="mx-auto max-w-md px-4 sm:max-w-3xl sm:px-6 lg:p-0 lg:h-full">
              <div className="aspect-w-10 aspect-h-6 rounded-xl lg:shadow-xl overflow-hidden sm:aspect-w-16 sm:aspect-h-7 lg:aspect-none lg:h-full">
                <img
                  className="object-cover mx-auto lg:mx-0 lg:h-full lg:w-full"
                  src={ScanGo}
                  alt=""
                />
              </div>
            </div>
          </div>
          <div className="mx-auto max-w-md px-4 sm:max-w-2xl sm:px-6 lg:px-0 lg:py-20 lg:max-w-none">
            <div className="text-white text-left">
              <h1 className="font-semibold mb-4 text-2xl">
                Our Scan & Go consultation
              </h1>
              <p className="text-base my-1 lg:my-2">
                XiViX’s novel Scan & Go Consultation is a quick, 15min
                high-precision Intra-Oral scan that facilitates 3D data
                acquisition of your mouth.
              </p>
              <p className="text-base my-1 lg:my-2">
                Digital scans will XiViX replace tedious traditional impressions,
                avoiding any discomfort, mess or discrepancies.
              </p>
              <p className="text-base my-3 lg:my-2">
                You can skip this step if you are a registered XiViX patient, and
                contact us for your final restorations.
              </p>
              <SecondaryButton
                onClick={scheduleScan}
                className="w-60 font-semibold mx-auto lg:mx-0"
                text="SCHEDULE A SCAN & GO"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Scan_Go


/* lg:grid lg:grid-cols-3 */